<template>
  <div v-if="blog">
    <HeaderAutor v-if="blog?.authors?.length" :blog-data="blog" />
    <CommunityHighlighted
      v-if="lastPost.blog"
      :link="`${COMMUNITY_BASE_URL}/${lastPost.blog.slug}/${lastPost.slug}`"
      :date="lastPost.published_date"
      :image="lastPost.image"
      :title-post="lastPost.title"
      :author="lastPost.author"
      :abstract="lastPost.abstract"
      class="container my-10"
    />
    <MeilisearchPosts
      :id-hidden-post="lastPost?.id ?? []"
      :authors="blog?.authors"
      :placeholder="$t('ui.placeholder.searchAutorBlog', { author: blog.authors[0]?.name })"
    />
    <ClientOnly>
      <div
        v-if="community.disclaimer"
        class="container grid grid-cols-1 lg:grid-cols-12 gap-3 mb-7"
      >
        <span
          class="col-span-1 lg:col-span-2 text-center lg:text-right text-gray-light leading-5.5"
          v-text="$t('community.downloadDisclaimer')"
        />
        <Markdown class="pt-disclaimer col-span-1 lg:col-span-10" :content="community.disclaimer" />
      </div>
    </ClientOnly>
    <Section
      v-if="blog?.show_documents_section"
      id="documents-section"
      class="bg-white-dark"
      :title="$t('community.documents')"
      grid="E"
    >
      <template #content>
        <MeilisearchDocuments />
      </template>
    </Section>
    <Section
      v-if="animations"
      class="bg-[#323232] cursor-pointer"
      grid="E"
      padding-y="p-0"
      @click="goToCajamar"
    >
      <template #content>
        <div class="overflow-hidden select-none">
          <VideoBanner :sources="animations" type="banner" />
        </div>
      </template>
    </Section>
  </div>
</template>

<script>
import Section from '@/components/Sections';
import Markdown from '@/components/Markdown';
import HeaderAutor from '@/components/Authors/Header';
import VideoBanner from '@/components/Banners/VideoBanner';
import MeilisearchPosts from '@/components/Meilisearch/Posts';
import { CAJAMAR_URL, COMMUNITY_BASE_URL } from '~/utils/enums';
import MeilisearchDocuments from '@/components/Meilisearch/Documents';
import CommunityHighlighted from '@/components/Banners/CommunityHighlighted';
export default {
  name: 'PtCommunityBlogSlug',
  components: {
    Section,
    Markdown,
    HeaderAutor,
    VideoBanner,
    MeilisearchPosts,
    MeilisearchDocuments,
    CommunityHighlighted
  },
  async setup() {
    const route = useRoute();
    const store = useStore();
    const { createHeadSeo } = useHeadSeo();
    const loadInjectComponents = ref(false);

    onBeforeMount(() => setTimeout(() => (loadInjectComponents.value = true), 1000));
    onMounted(async () => {
      await store.dispatch('strapi/getCommunity');
      await store.dispatch('strapi/getLastPostByBlog', {
        slug: route.params.blog,
        limit: 1
      });
    });

    const { data } = await useAsyncData('homeBlog', async () => {
      const blog = await store.dispatch('strapi/getBlogBySlug', { slug: route.params.blog });

      return { blog };
    });
    const blog = computed(() => data.value.blog);
    const community = computed(() => store.getters['strapi/getByField']('community'));
    const lastPost = computed(() => store.getters['strapi/getByField']('lastPostByBlog'));
    const animations = computed(() => store.getters['strapi/getByField']('common.animations'));
    const goToCajamar = () => window.location.replace(CAJAMAR_URL);

    watch(
      blog,
      val => {
        if (val) {
          const {
            meta: {
              title,
              description,
              og_image: { url }
            }
          } = val;
          createHeadSeo(title, description, url);
        }
      },
      { immediate: true, deep: true }
    );
    return {
      blog,
      lastPost,
      community,
      animations,
      goToCajamar,
      COMMUNITY_BASE_URL,
      loadInjectComponents
    };
  }
};
</script>
